import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/sales/onboarding-jobs")({
  component: Outlet,
});
